import { React } from 'react';
import Header from '../Components/Header';
import ScrollBar from '../Components/ScrollBar';
import OurServices from '../Components/OurServices';
import AboutHome from '../Components/AboutHome';
import HeroSection from '../Components/HeroSection';
import video from '../Assets/videos/robotic_arm_video.mov'
import { OrbitControls, Environment, useGLTF } from "@react-three/drei";
import { Canvas } from '@react-three/fiber';
import heroimg from '../Assets/Images/yellow_robotic_arm.png';
import OpportunityTimeline from '../Components/OpportunityTimeline';
import { FloatingBubbles } from '../Components/FloatingBubbles';

// import model from '../Assets/scene.gltf';

// const RoboticArm = () => {
//     const { scene } = useGLTF("../Assets/scene.gltf"); // Update the path
//     return <primitive object={scene} scale={1.5} />;
//   };
  
const Home = () => {
    return(
        <>
        {/* <HeroSection /> */}
        {/* <div data-elementor-type="wp-page" data-elementor-id="6" class="elementor elementor-6"> */}
			<div class="elementor-element elementor-element-a857361 e-flex e-con-boxed e-con e-parent" data-id="a857361" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
				<div class="e-con-inner">
		            <div class="elementor-element elementor-element-4e7403e e-con-full e-flex e-con e-child" data-id="4e7403e" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
				        <div class="elementor-element elementor-element-322591a elementor-widget__width-inherit elementor-invisible elementor-widget elementor-widget-heading" data-id="322591a" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
				            <div class="elementor-widget-container">
                                <h5 class="elementor-heading-title elementor-size-default">Welcome to HHG INDUSTRIES PRIVATE LIMITED</h5>		
                            </div>
				        </div>
				        <div class="elementor-element elementor-element-3973fc8 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="3973fc8" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
				            <div class="elementor-widget-container">
			                    <div  class="jeg-elementor-kit jkit-animated-text jeg_module_6_2_676b7978d380f"  data-style="highlighted" data-text="Robotics " data-shape="underline">
                                    <h1 class="animated-text"><span class="normal-text style-color">Tailored Automation Solutions for </span>
                                        <span class="dynamic-wrapper style-color">
                                            <span class="dynamic-text">Every</span>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none"><path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/></svg>
                                        </span>
                                        <span class="normal-text style-color"> Industry</span>
                                    </h1>
                                </div>		
                            </div>
				        </div>
				        <div class="elementor-element elementor-element-b84d716 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="b84d716" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
				            <div class="elementor-widget-container">
						        <p>Our scalable automation solutions deliver maximum ROI and ensure peak operational efficiency.</p>						
                            </div>
				        </div>
		                <div class="elementor-element elementor-element-159205c e-flex e-con-boxed e-con e-child" data-id="159205c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
					        <div class="e-con-inner">
				                <div class="elementor-element elementor-element-1a6a7d3 elementor-widget__width-auto elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_button" data-id="1a6a7d3" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:400,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_button.default">
				                    <div class="elementor-widget-container">
		                            	<div  class="jeg-elementor-kit jkit-button  icon-position-before jeg_module_6_3_676b7978d4976" >
                                            <a href="ContactUs"  class="jkit-button-wrapper"  >Get Started</a>
                                        </div>
                                    </div>
				                </div>
				                <div class="elementor-element elementor-element-1c1eaf7 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_button" data-id="1c1eaf7" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:500,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_button.default">
				                    <div class="elementor-widget-container">
			                            <div  class="jeg-elementor-kit jkit-button  icon-position-after jeg_module_6_4_676b7978d520c" >
                                            <div class="jkit-button-wrapper"  ><a href="/about">Learn More</a><i aria-hidden="true" class="jki jki-right-arrow-light"></i></div>
                                        </div>
                                    </div>
				                </div>
					        </div>
				        </div>
				    </div>
		            <div class="elementor-element elementor-element-a3a96a0 e-con-full e-flex e-con e-child" data-id="a3a96a0" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
		                <div class="elementor-element elementor-element-430cb6c e-flex e-con-boxed e-con e-child" data-id="430cb6c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
					        <div class="e-con-inner">
				                <div class="elementor-element elementor-element-d7e2735 elementor-widget__width-initial elementor-widget elementor-widget-jkit_fun_fact" data-id="d7e2735" data-element_type="widget" data-widget_type="jkit_fun_fact.default">
				                    <div class="elementor-widget-container">
			                            <div  class="jeg-elementor-kit jkit-fun-fact align-center hover-from-left elementor-animation- jeg_module_6_5_676b7978d7934" >
                                            <div class="fun-fact-inner">
                                                <div class="content">
                                                    <div class="number-wrapper"><span class="prefix"></span>
                                                        <span class="number" data-value="24000" data-animation-duration="3500">24000</span>
                                                        <span class="suffix" style={{fontSize:'24px'}}>sq. ft.</span><sup class="super"></sup>
                                                    </div>
                                                    <h3 class="title">State of Art Plant</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
				                </div>
					        </div>
				        </div>
				        <div class="elementor-element elementor-element-ee561ea elementor-widget__width-inherit elementor-widget elementor-widget-image" data-id="ee561ea" data-element_type="widget" data-widget_type="image.default">
                            <div class="elementor-widget-container">
                             {/* 3D Canvas */}
                                {/* <div className="canvas-container">
                                    <Canvas>
                                    <ambientLight intensity={0.5} />
                                    <directionalLight position={[10, 10, 10]} />
                                    <RoboticArm />
                                    <OrbitControls enableZoom={true} />
                                    <Environment preset="sunset" />
                                    </Canvas>
                                </div> */}
                            {/* <video 
                                    width="800" 
                                    height="871" 
                                    controls 
                                    autoplay 
                                    loop 
                                    muted 
                                    src={video}>
                                    Your browser does not support the video tag.
                                </video> */}
                                <img decoding="async" width="800" height="871" src={heroimg} class="attachment-large size-large wp-image-414" alt="" 
                                // srcset="https://templatekit.jegtheme.com/robix/wp-content/uploads/sites/428/2024/01/yellow-robotic-arms-robix-compress-XG2PU36-941x1024.png 941w, https://templatekit.jegtheme.com/robix/wp-content/uploads/sites/428/2024/01/yellow-robotic-arms-robix-compress-XG2PU36-276x300.png 276w, https://templatekit.jegtheme.com/robix/wp-content/uploads/sites/428/2024/01/yellow-robotic-arms-robix-compress-XG2PU36-768x836.png 768w, https://templatekit.jegtheme.com/robix/wp-content/uploads/sites/428/2024/01/yellow-robotic-arms-robix-compress-XG2PU36-800x870.png 800w, https://templatekit.jegtheme.com/robix/wp-content/uploads/sites/428/2024/01/yellow-robotic-arms-robix-compress-XG2PU36.png 1012w" 
                                sizes="(max-width: 800px) 100vw, 800px" />															
                            </div>
				        </div>
                        <div
  className="elementor-element elementor-element-6521a7e elementor-hidden-mobile e-flex e-con-boxed e-con e-child"
  data-id="6521a7e"
  data-element-type="container"
  data-settings='{"content_width":"boxed"}'
  style={{ opacity: 0.99, zIndex: 1000 }}
>
					        <div class="e-con-inner">
				                <div class="elementor-element elementor-element-bba4332 elementor-widget__width-initial elementor-widget elementor-widget-jkit_fun_fact" data-id="bba4332" data-element_type="widget" data-widget_type="jkit_fun_fact.default">
				                    <div class="elementor-widget-container">
			                            <div  class="jeg-elementor-kit jkit-fun-fact align-center hover-from-left elementor-animation- jeg_module_6_6_676b7978d9e56" >
                                            <div class="fun-fact-inner">
                                                <div class="content">
                                                    <div class="number-wrapper">
                                                        <span class="prefix"></span>
                                                        <span class="number" data-value="20" data-animation-duration="3500">0</span>
                                                        <span class="suffix"></span><sup class="super"> +</sup>
                                                    </div>
                                                        <h3 class="title">Successful Projects</h3>
                                                </div>
                                            </div>
                                        </div>		
                                    </div>
                                </div>
                            </div>
				        </div>
				    </div>
				</div>
			</div>
       

        <AboutHome />
                {/* </div> */}
        <OurServices />
<OpportunityTimeline/>
<FloatingBubbles/>
       </>
    )
}

export default Home;
